import { render, staticRenderFns } from "./KanbanSettingsOverlay.vue?vue&type=template&id=867737c8&scoped=true"
import script from "./KanbanSettingsOverlay.vue?vue&type=script&lang=js"
export * from "./KanbanSettingsOverlay.vue?vue&type=script&lang=js"
import style0 from "./KanbanSettingsOverlay.vue?vue&type=style&index=0&id=867737c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867737c8",
  null
  
)

export default component.exports